import { Injectable } from '@angular/core';
import { AppConfigService as SitewideAppConfigService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable } from 'rxjs';
import { Config } from '../../data-models/config.interfaces';
import { AppConfigMap } from '../models/common.interfaces';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  constructor(private sitewideAppConfigService: SitewideAppConfigService) {}

  /**
   * Initialize the config object by requesting (idp-config.json) from AEM
   */
  initializeAppConfig(): Observable<AppConfigMap> {
    return this.sitewideAppConfigService.initializeAppConfig();
  }

  /**
   * Return value by key from the config object (idp-config.json)
   */
  getConfigValue(appName: string, key: string): Observable<string> {
    return this.sitewideAppConfigService.getConfigValue(appName, key);
  }

  getConfig(key: string): Config {
    return this.sitewideAppConfigService.getConfig(key);
  }
}
